import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getTotalLabelCost = {
  name: "getTotalLabelCost" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
